module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Clip-f92ce05eb511b792a47a3f1268dd16e8.svg";